"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ReducerCore = exports.InitStateCore = exports.ActionTypesCore = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// import {
//   RecaptchaProvider,
//   ReCaptchaVerify,
// } from '@workspace-tenants/recaptcha';

var InitStateCore = {
  modalShow: false,
  loginFailedModalShow: false,
  newPasscodeModalShow: false,
  isAccountLocked: false,
  alphaNumericVal: '',
  loginModal: {
    prospectName: 'prospectName',
    adminEmailId: 'sandbox+lehigh@ovrture.com',
    adminCellNumber: '1234567890',
    username: 'username',
    passcode: 'passcode',
    siteId: 1,
    reportId: 1,
    loginType: 'loginType',
    typeName: 'Site'
  }
};
exports.InitStateCore = InitStateCore;
var ReducerCore = function ReducerCore(state, action) {
  switch (action.type) {
    case ActionTypesCore.setModalShow:
      return {
        modalShow: action.payload,
        loginFailedModalShow: state.loginFailedModalShow,
        alphaNumericVal: state.alphaNumericVal,
        loginModal: state.loginModal
      };
    case ActionTypesCore.setLoginFailedModalShow:
      return {
        modalShow: state.modalShow,
        loginFailedModalShow: action.payload,
        alphaNumericVal: state.alphaNumericVal,
        loginModal: state.loginModal
      };
    case ActionTypesCore.setAlphaNumericVal:
      return {
        modalShow: state.modalShow,
        loginFailedModalShow: state.loginFailedModalShow,
        alphaNumericVal: action.payload,
        loginModal: state.loginModal
      };
    case ActionTypesCore.setShowAccountLocked:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAccountLocked: action.payload
      });
    case ActionTypesCore.setNewPasscodeModalShow:
      return _objectSpread(_objectSpread({}, state), {}, {
        newPasscodeModalShow: action.payload
      });
    case ActionTypesCore.onLoad:
      return onLoad(state, action.title, action.reCaptchaSiteKey);
    case ActionTypesCore.onSubmit:
      return onSubmit(state, action.payload, action.reCaptchaSiteKey);
    default:
      return state;
  }
};
exports.ReducerCore = ReducerCore;
var ActionTypesCore = {
  setModalShow: '@@commonlogin/setModalShow',
  setLoginFailedModalShow: '@@commonlogin/setLoginFailedModalShow',
  setAlphaNumericVal: '@@commonlogin/setAlphaNumericVal',
  onLoad: '@@commonlogin/onLoad',
  onSubmit: '@@commonlogin/onSubmit',
  setShowAccountLocked: '@@commonlogin/accountLocked'
};
exports.ActionTypesCore = ActionTypesCore;
var onLoad = function onLoad(state, title, reCaptchaSiteKey) {
  document.title = title;
  if (reCaptchaSiteKey) {
    // RecaptchaProvider('passcode_recaptcha_key', reCaptchaSiteKey, function () {
    //   console.log('ReCaptcha Provider loaded!');
    // });
  }
  return state;
};
var onSubmit = function onSubmit(state, formData, reCaptchaSiteKey) {
  var formVal = {
    modalShow: state.modalShow,
    loginFailedModalShow: true,
    alphaNumericVal: state.alphaNumericVal,
    loginModal: state.loginModal
  };
  if (formData['username'] === '' && formData['passcode'] === '') {
    return formVal;
  }
  if (formData['passcode'] === '') {
    return formVal;
  }
  if (reCaptchaSiteKey) {
    // ReCaptchaVerify(reCaptchaSiteKey, 'passcode_submit', function (token) {
    //   // call a backend API to verify reCAPTCHA response
    //   console.log('g-recaptcha-response: ' + token);
    //   //dispatch(loginUser(formData['username'], formData['passcode']));
    // });
  }
  return state;
};
var _default = ReducerCore;
exports.default = _default;